import { MarketboardDict } from "../../../contracts";

export const marketBoardDict: MarketboardDict = {
    errorTitle: "Something went wrong",
    errorInfo: "An error has occurred. Please check your internet connection or try refreshing the page. If the problem persists, contact our support.",
    missingData: "No available bets at the moment",
    missingDataInfo: "Check out other players, or navigate to the player's upcoming event to view all available bets.",
    milestonesTooltipText: "Tap left or right to change the players line.",
    MiddleTermAt: "at",
    MiddleTermVs: "vs"
}